/* eslint-disable */
import "./Screens.css";
import React from "react";
import moment from "moment";
import "moment/locale/pt-br";
import ReactTable from "react-table";
import { connect } from "react-redux";
import Fullscreen from "react-full-screen";
import Card from "../../components/Card/Card.jsx";
import { db } from "../../services/firebase";
import ScreenForm from "../../forms/ScreenForm.jsx";
import Modal from "../../components/Modal/Modal.jsx";
import { toArray, map, isEmpty, reduce, orderBy } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../components/SweetSpinner/SweetSpinner.jsx";
import { style as NotifyStyle } from "../../variables/Variables.jsx";
import { faPlus, faMinus, faTrash } from "@fortawesome/fontawesome-free-solid";
import {
  Grid,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
  FormGroup,
} from "react-bootstrap";

class Screens extends React.Component {
  state = {
    queries: [],
    observers: [],
    selectedScreens: [],
    creatingObservers: false,
    fetching: true,
    targetQuery: null,
    queryModal: false,
    alert: null,
    loading: false,
    _notificationSystem: null,
    isFullscreen: false,
    isFullscreenPopulated: false,
    resultsObject: {},
    fullscreenHeader: null,
    activeShift: null,
  };
  componentDidMount() {
    this._fetch();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentDidUpdate() {
    const {
      creatingObservers,
      selectedScreens,
      resultsObject,
      isFullscreen,
      isFullscreenPopulated,
    } = this.state;

    if (creatingObservers) {
      selectedScreens.length &&
        Object.keys(resultsObject).length === selectedScreens.length &&
        this.setState({
          creatingObservers: false,
          isFullscreenPopulated: true,
        });
    }

    if (!isFullscreen && isFullscreenPopulated) {
      let resetResults = {};
      let resetSelected = [];
      this.setState({
        resultsObject: resetResults,
        selectedScreens: resetSelected,
        isFullscreenPopulated: false,
        fullscreenHeader: null,
      });
    }
  }

  render() {
    const {
      queries,
      fetching,
      selectedScreens,
      isFullscreen,
      clientTime,
      lastUpdate,
    } = this.state;

    return (
      <div className="main-content">
        {this.state.alert}
        {this.queryModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Grid fluid>
          <Card
            content={
              <div>
                <Row>
                  <Col md={12}>
                    <Button
                      bsStyle="default"
                      wd
                      style={{ marginBottom: 10 }}
                      onClick={() => {
                        this.setState({ isFullscreen: true });
                        this._createObservers();
                      }}
                      disabled={!selectedScreens.length}
                    >
                      Iniciar exibição
                    </Button>

                    <Button
                      bsStyle="default"
                      wd
                      className="pull-right"
                      style={{ marginBottom: 10 }}
                      onClick={() => this.setState({ queryModal: true })}
                    >
                      Adicionar filtro
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <ReactTable
                      columns={[
                        { Header: "Filtro", accessor: "screenParams" },
                        {
                          Header: "Ações",
                          accessor: "",
                          Cell: ({ value }) => (
                            <div style={{ textAlign: "center" }}>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`selected_${value.id}`}>
                                    {selectedScreens.indexOf(value.id) <= -1
                                      ? "Adicionar a lista"
                                      : "Remover da lista"}
                                  </Tooltip>
                                }
                              >
                                <a
                                  className="btn btn-simple btn-default btn-icon"
                                  onClick={() => this._handleSelect(value)}
                                >
                                  <FontAwesomeIcon
                                    className="text-dark"
                                    icon={
                                      selectedScreens.indexOf(value.id) <= -1
                                        ? faPlus
                                        : faMinus
                                    }
                                  />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`remove_${value.id}`}>
                                    Excluir
                                  </Tooltip>
                                }
                              >
                                <a
                                  className="btn btn-simple btn-default btn-icon"
                                  onClick={() => {
                                    this.setState({ targetQuery: value });
                                    this.removeAlert();
                                  }}
                                >
                                  <FontAwesomeIcon
                                    className="text-danger"
                                    icon={faTrash}
                                  />
                                </a>
                              </OverlayTrigger>
                            </div>
                          ),
                        },
                      ]}
                      data={queries}
                      loading={fetching}
                      defaultPageSize={10}
                      className="-striped -highlight"
                      previousText="Anterior"
                      nextText="Próximo"
                      loadingText="Carregando"
                      noDataText="Nenhuma tela encontrada"
                      pageText="Página"
                      ofText="de"
                      rowsText="Registros"
                    />
                  </Col>
                </Row>

                <Fullscreen
                  enabled={isFullscreen}
                  onChange={(isFullscreen) => this.setState({ isFullscreen })}
                >
                  {isFullscreen && (
                    <div className="screens__fullscreen">
                      {this._handleFullscreenContent()}
                    </div>
                  )}
                </Fullscreen>
              </div>
            }
          />
        </Grid>
      </div>
    );
  }

  _fetch = () => {
    const { company } = this.props.user;

    this.setState({ fetching: true });

    db.collection("companies")
      .doc(company)
      .collection("queries")
      .onSnapshot((querySnapshot) => {
        if (!querySnapshot.empty) {
          const queries = [];
          querySnapshot.forEach((s) => queries.push({ ...s.data(), id: s.id }));
          this.setState({ queries, fetching: false });
        } else {
          this.setState({ fetching: false });
        }
      });
  };

  _setQuery = (values) => {
    this.setState({ queryModal: false });
    this.waitAlert("Adicionando tela", true);

    let query = {};
    const { company } = this.props.user;

    query["product"] = values.product ? values.product.value : null;
    query["indicator"] = values.indicator ? values.indicator.value : null;
    query["place"] = values.place ? values.place.value : null;
    query["line"] = values.line ? values.line.value : null;
    query["table"] = values.table ? values.table.value : null;

    let screenParams = `${values.product.label} - ${values.indicator.label} (${
      values.place ? `${values.place.label}` : ""
    } ${values.line ? `${values.line.label}` : ""} ${
      values.table ? `${values.table.label}` : ""
    })`;

    db.collection("companies")
      .doc(company)
      .collection("queries")
      .add({
        ...query,
        screenParams,
        productName: values.product.label,
        indicatorName: values.indicator.label,
        placeName: values.place ? values.place.label : null,
        lineName: values.line ? values.line.label : null,
        tableName: values.table ? values.table.label : null,
      })
      .then(() => {
        this.hideAlert();
        this.notify("Filtro adicionado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao adicionar filtro", "error");
      });
  };

  _removeQuery = () => {
    this.setState({ queryModal: false });
    this.waitAlert("Removendo tela", false);

    const { targetQuery } = this.state;
    const { company } = this.props.user;

    db.collection("companies")
      .doc(company)
      .collection("queries")
      .doc(targetQuery.id)
      .delete()
      .then(() => {
        this.hideAlert();
        this.notify("Filtro removido", "success");
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao remover filtro", "error");
      });
  };

  _handleSelect = (item) => {
    const selectedScreens = [...this.state.selectedScreens]; //shallow copy
    if (selectedScreens.length < 5) {
      selectedScreens.indexOf(item.id) <= -1
        ? selectedScreens.push(item.id)
        : selectedScreens.splice(selectedScreens.indexOf(item.id, 1));

      this.setState({ selectedScreens });
    } else {
      this.notify(
        "Você já selecionou 5 filtros, atingindo o limite máximo.",
        "warning"
      );
    }
  };

  queryModal = () => {
    const { targetQuery, queryModal } = this.state;
    return (
      <Modal
        title="Adicionar filtro"
        isOpen={queryModal}
        content={
          <ScreenForm
            onSubmit={(values) => this._setQuery(values)}
            companyID={this.props.user.company}
            handleCancel={() =>
              this.setState({ queryModal: false, targetQuery: null })
            }
          />
        }
      />
    );
  };

  _handleFullscreenContent = () => {
    const {
      isFullscreen,
      creatingObservers,
      resultsObject,
      queries,
      selectedScreens,
      fullscreenHeader,
    } = this.state;

    if (isFullscreen && creatingObservers && isEmpty(resultsObject)) {
      return <h1>Obtendo dados...</h1>;
    }

    if (isFullscreen && !creatingObservers && isEmpty(resultsObject)) {
      return <h1>Nenhum dado foi encontrado</h1>;
    }

    if (isFullscreen && !creatingObservers && !isEmpty(resultsObject)) {
      return (
        <div>
          <div className="screens__header">
            <div className="screens__header--title">
              {!fullscreenHeader && this._createHeader()}
              {fullscreenHeader || "..."}
            </div>

            <div className="screens__header--index--group">
              <div className="screens__header--index">1ª Coleta</div>
              <div className="screens__header--index">2ª Coleta</div>
              <div className="screens__header--index">3ª Coleta</div>
              <div className="screens__header--index">4ª Coleta</div>
              <div className="screens__header--index">5ª Coleta</div>
              <div className="screens__header--index">6ª Coleta</div>
              <div className="screens__header--index">7ª Coleta</div>
              <div className="screens__header--index">8ª Coleta</div>
            </div>
          </div>

          <div className="screens__list">
            {map(selectedScreens, (screen) => {
              let queryIndex = queries.findIndex((x) => x.id === screen);
              return (
                <div className="screens__item" key={screen}>
                  <div className="screens__indicator">
                    <div className="screens__indicator--name">
                      {queries[queryIndex].productName} -{" "}
                      {queries[queryIndex].indicatorName}
                    </div>
                    <div className="screens__indicator--numbers">
                      <div className="screens__indicator--block">
                        <div className="screens__indicator--title">Meta</div>
                        <div className="screens__indicator--big-number">
                          {this._createGoalOrAvg(screen, "goal")}
                        </div>
                      </div>
                      <div className="screens__indicator--block">
                        <div className="screens__indicator--title">Média</div>
                        <div className="screens__indicator--big-number">
                          {this._createGoalOrAvg(screen, "avg")}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="screens__result">
                    {map(
                      orderBy(toArray(resultsObject[screen]), [
                        "registeredAt",
                        "asc",
                      ]),
                      (result, index) => {
                        return (
                          <div
                            className="screens__result--item"
                            key={JSON.stringify(result)}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#EEE" : "#FFF",
                            }}
                          >
                            <div
                              className="screens__result--value"
                              style={{
                                color:
                                  result.registered > result.goal
                                    ? "#B71212"
                                    : "#87CB16",
                              }}
                            >
                              {Number(result.registered).toFixed(1)}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
  };

  buildRef = (db, company, collection) =>
    db.collection("companies").doc(company).collection(collection);

  buildObserver = (props, refs, identifier, shiftID) => {
    let observer = refs["results"];
    const { product, indicator, place, line, table } = props;

    observer = observer.where("shift.value", "==", shiftID);
    // '    // observer = observer.where(
    //   "registeredAt",
    //   ">=",
    //   moment().startOf("day").valueOf()
    // );
    // observer = observer.where(
    //   "registeredAt",
    //   "<=",
    //   moment().endOf("day").valueOf()
    // );

    product && (observer = observer.where("product", "==", product));
    indicator && (observer = observer.where("indicator", "==", indicator));
    place && (observer = observer.where("place", "==", place));
    line && (observer = observer.where("line", "==", line));
    table && (observer = observer.where("table", "==", table));

    return observer.onSnapshot((snap) => {
      if (!snap.empty) {
        let resultsObject = { ...this.state.resultsObject };
        console.log(resultsObject);
        snap.forEach((s) => {
          let PromiseStack = [];
          resultsObject[identifier] = {
            ...resultsObject[identifier],
            [s.id]: { ...s.data() },
          };
          PromiseStack.push(
            product &&
              refs["products"]
                .doc(s.data().product)
                .get()
                .then(
                  (d) =>
                    d.exists &&
                    (resultsObject[identifier] = {
                      ...resultsObject[identifier],
                      [s.id]: {
                        ...resultsObject[identifier][s.id],
                        product: d.data().name,
                      },
                    })
                ),

            indicator &&
              refs["indicators"]
                .doc(s.data().indicator)
                .get()
                .then(
                  (d) =>
                    d.exists &&
                    (resultsObject[identifier] = {
                      ...resultsObject[identifier],
                      [s.id]: {
                        ...resultsObject[identifier][s.id],
                        indicator: d.data().name,
                        goal: d.data().goal,
                      },
                    })
                ),

            place &&
              refs["places"]
                .doc(s.data().place)
                .get()
                .then(
                  (d) =>
                    d.exists &&
                    (resultsObject[identifier] = {
                      ...resultsObject[identifier],
                      [s.id]: {
                        ...resultsObject[identifier][s.id],
                        place: d.data().name,
                      },
                    })
                ),

            line &&
              refs["lines"]
                .doc(s.data().line)
                .get()
                .then(
                  (d) =>
                    d.exists &&
                    (resultsObject[identifier] = {
                      ...resultsObject[identifier],
                      [s.id]: {
                        ...resultsObject[identifier][s.id],
                        line: d.data().name,
                      },
                    })
                ),

            table &&
              refs["tables"]
                .doc(s.data().table)
                .get()
                .then(
                  (d) =>
                    d.exists &&
                    (resultsObject[identifier] = {
                      ...resultsObject[identifier],
                      [s.id]: {
                        ...resultsObject[identifier][s.id],
                        table: d.data().name,
                      },
                    })
                )
          );

          return Promise.all(PromiseStack)
            .then(() => {
              PromiseStack.length = 0;
              this.setState({ resultsObject });
            })
            .catch((e) => {
              console.log(e);
              this.notify("Nenhum dado para exibir", "warning");
            });
        });
      } else {
        let resultsObject = { ...this.state.resultsObject };
        let index = this.state.queries.findIndex((x) => x.id === identifier);
        this.notify(
          `O filtro "${this.state.queries[index].screenParams}" não retornou nenhum dado.`,
          "warning"
        );
        resultsObject = { ...resultsObject, [identifier]: null };
        this.setState({ resultsObject });
      }
    });
  };

  reduceRefs = (db, company, collections) =>
    reduce(
      collections,
      (acc, collection) => {
        acc[collection] = this.buildRef(db, company, collection);
        return acc;
      },
      {}
    );

  _createObservers = () => {
    let companyShifts = {};
    const { company } = this.props.user;
    const { selectedScreens } = this.state;

    const refs = this.reduceRefs(db, this.props.user.company, [
      "queries",
      "results",
      "products",
      "indicators",
      "shifts",
      "places",
      "lines",
      "tables",
    ]);

    this.setState({ creatingObservers: true }, (_) =>
      console.log("creating observers...")
    );

    db.collection("companies")
      .doc(company)
      .collection("shifts")
      .get()
      .then((shifts) => {
        if (!shifts.empty) {
          shifts.forEach((shift) => {
            let start = shift.data().startAt.split(":");
            let end = shift.data().endAt.split(":");
            companyShifts[shift.id] = {
              id: shift.id,
              name: shift.data().name,
              startTodayAt: moment()
                .hour(Number(start[0]))
                .minute(Number(start[1]))
                .second(0)
                .valueOf(),
              endTodayAt: moment()
                .hour(Number(end[0]))
                .minute(Number(end[1]))
                .second(0)
                .valueOf(),
            };
          });

          let clientTime = moment().valueOf();

          map(companyShifts, (shift) => {
            if (shift.startTodayAt <= clientTime) {
              selectedScreens.forEach((screen) => {
                refs["queries"]
                  .doc(screen)
                  .get()
                  .then((snap) =>
                    snap.exists
                      ? this.buildObserver(snap.data(), refs, screen, shift.id)
                      : this.notify(
                          "Filtro inválido ou inexiste. Verifique seus filtros.",
                          "error"
                        )
                  );
              });

              this.setState({ activeShift: shift.name });
            }
          });

          this.setState({ creatingObservers: false });
        } else {
          this.notify(
            "Nenhum turno localizado. Sem turnos, é impossível manter os dados sincronizados.",
            "warning"
          );
          this.setState({
            isFullscreen: false,
            fullscreenHeader: null,
            isFullscreenPopulated: false,
            creatingObservers: false,
          });
        }
      })
      .catch((e) =>
        this.notify("Erro ao carregar valores. Tente novamente.", "error")
      );
  };

  _createHeader = () => {
    const { queries, selectedScreens, activeShift } = this.state;
    const lines = [];
    const places = [];
    const tables = [];

    map(selectedScreens, (screen) => {
      let queryIndex = queries.findIndex((x) => x.id === screen);
      lines.push(queries[queryIndex].lineName);
      places.push(queries[queryIndex].placeName);
      tables.push(queries[queryIndex].tableName);
    });

    let isLineEqual = true;
    let isPlaceEqual = true;
    let isTableEqual = true;

    lines.forEach((l) => (l !== lines[0] ? (isLineEqual = false) : null));
    places.forEach((p) => (p !== places[0] ? (isPlaceEqual = false) : null));
    tables.forEach((t) => (t !== tables[0] ? (isTableEqual = false) : null));

    return this.setState({
      fullscreenHeader: `${activeShift ? `${activeShift} - ` : ""} ${
        isPlaceEqual && places[0] ? places[0] : "Múltiplos locais"
      } - ${isLineEqual && lines[0] ? lines[0] : "Múltiplas linhas"} - ${
        isTableEqual && tables[0] ? tables[0] : "Múltiplas mesas"
      }`,
    });
  };

  _createGoalOrAvg = (screenIndex, returnType) => {
    const { resultsObject } = this.state;
    let totalWeight = 0;
    let registers = 0;
    let goalArr = [];
    map(resultsObject[screenIndex], (result) => {
      registers++;
      totalWeight += result.registered;
      goalArr.push(result.goal);
    });
    let avg = totalWeight / registers;
    let goal = goalArr.length ? goalArr[0] : "-";

    return returnType === "avg" ? (avg ? Number(avg).toFixed(1) : "-") : goal;
  };

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 60,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };

  removeAlert = () => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._removeQuery()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        >
          A tela não estará mais disponível para exibição
        </SweetAlert>
      ),
    });
  };
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default connect(mapStateToProps, null)(Screens);



// WEBPACK FOOTER //
// ./src/views/Screens/Screens.jsx